import React, { useEffect, useRef, useState } from 'react'
import { Card, DatePicker, Radio, Spin } from 'antd'
import { SBack, SFormImagesList, SGeneralForms } from 'shj-components'
import dayjs from 'dayjs'
import { useNavigate, useParams } from 'react-router-dom'
import { getVendorInfo } from '@/services/workerManagement'
import { httpDictServ } from '@/services'
import { getEnums, searchCompanyList } from '@/services/homeService'
import { authenticationModal } from '../component/authenticationModal'
import { authDict, useFileUrlPrefix } from 'shj-utils'
import { isArray } from 'lodash-es'
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'

export const WorkerManagementAddOrEdit: React.FC<any> = props => {
  const { id } = useParams()
  const formRef = useRef<any>()
  const [typeKey, setTypeKey] = useState<string>('0')
  const [info, setInfo] = useState<any>(null)
  const [bankItem, setBankItem] = useState<any>(false)
  const [spinning, setSpinning] = useState<any>(false)
  const fileUrlPrefix = useFileUrlPrefix()
  const { RangePicker } = DatePicker
  const history = useNavigate()
  const httpOptionsFn = (): Promise<Record<string, any>> => {
    return new Promise(async resolve => {
      const billingTypeEnum = await getEnums(
        'plus-pm',
        'com.shj.saas.plus.pm.domain.vendor.enums.BillingTypeEnum'
      )
      const verndorTypeEnum: any = await getEnums(
        'plus-pm',
        'com.shj.saas.plus.pm.domain.vendor.enums.VerndorTypeEnum'
      )
      const taxRateList = await getTaxRateList()
      const companyList = await searchCompanyList()
      const distributionTypeEnum = await getEnums(
        'plus-pm',
        'com.shj.saas.plus.pm.domain.vendor.enums.DistributionTypeEnum'
      )
      const signatureModeEnum = await getEnums(
        'plus-pm',
        'com.shj.saas.plus.pm.domain.vendor.enums.SignatureModeEnum'
      )
      resolve({
        typeCode: [
          { label: verndorTypeEnum[1].description, value: verndorTypeEnum[1].key },
          { label: verndorTypeEnum[0].description, value: verndorTypeEnum[0].key },
        ],
        billingTypeEnum,
        taxRateList,
        companyList,
        distributionTypeEnum,
        signatureModeEnum,
      })
    })
  }
  useEffect(() => {
    initFn()
  }, [])
  // 处理数据
  const dealData = obj => {
    const newObj = { ...obj }
    if (isArray(newObj?.vendorOrgList) && newObj?.vendorOrgList.length > 0) {
      for (let m of newObj?.vendorOrgList) {
        if (m?.startDate) {
          m.cycleTime = [dayjs(m?.startDate), dayjs(m?.endDate)]
        }
      }
    } else {
      newObj.vendorOrgList = []
    }
    return newObj
  }
  const initFn = () => {
    if (id) {
      setSpinning(true)
      getVendorInfo({ id }).then(res => {
        setSpinning(false)
        res = dealData(res)
        setTypeKey(res.typeCode)
        res.fileInfolist =
          res.fileInfolist &&
          res.fileInfolist.map(item => {
            return {
              uid: item,
              url: fileUrlPrefix + item,
              relativePath: item,
            }
          })
        if (res?.vendorAccountInfo) {
          setBankItem(true)
          let accountImgBackUrl = [
            {
              uid: res.vendorAccountInfo.accountImgBackUrl,
              url: fileUrlPrefix + res.vendorAccountInfo.accountImgBackUrl,
              relativePath: res.vendorAccountInfo.accountImgBackUrl,
            },
          ]
          let accountImgFrontUrl = [
            {
              uid: res.vendorAccountInfo.accountImgFrontUrl,
              url: fileUrlPrefix + res.vendorAccountInfo.accountImgFrontUrl,
              relativePath: res.vendorAccountInfo.accountImgFrontUrl,
            },
          ]
          formRef.current?.onFormRef()?.setFieldsValue({
            ...res,
            ...res?.vendorAccountInfo,
            accountImgBackUrl,
            accountImgFrontUrl,
          })
        } else {
          formRef.current?.onFormRef()?.setFieldsValue({ ...res })
        }
        formRef.current?.onFormRef()?.setFieldsValue({ ...res })
        let infoData = { ...formRef.current?.onFormRef()?.getFieldsValue() }
        setInfo(infoData)
      })
    }
  }
  const getTaxRateList = () => {
    return httpDictServ({ parentKey: 'taxRate', enable: 1 }).then((response: any) => {
      return response
    })
  }
  const onAuthentication = info => {
    authenticationModal({
      title: info?.typeCode === 'personal' ? '个人认证' : '商家认证',
      detailsData: info,
      info,
      isView: info.statusName === '已认证',
      onclose: (flag) => {
        if(flag === true) {
          history('/config/serviceConfig/workerManagement')
        }
      },
    })
  }
  const changeType = v => {
    setTypeKey(v.target.value)
  }
  const setPhone = (label, labelFlag) => {
    getVendorInfo({ id, labelFlag }).then(async (res: any) => {
      formRef?.current?.onFormRef()?.setFieldValue(label, res[label])
      info[label] = res[label]
      setInfo({ ...info })
    })
  }
  return (
    <Spin spinning={spinning}>
      <SBack title={info?.name ? info?.name + '详细信息' : '承包商详情'} level={2}>
        <Card bordered={false} style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
          <SGeneralForms
            isFooterBtn={false}
            footerAlign="right"
            httpOptionsFn={httpOptionsFn}
            ref={formRef}
            isHideResetBtn={true}
            isHideGobackBtn={true}
            isDetail={true}
            configs={[
              {
                title: '承包商详情',
                titleMode: 'drawer',
                formItem: [
                  { label: 'id', name: 'id', hidden: true },
                  {
                    name: 'typeCode',
                    label: '类型',
                    spanCol: 24,
                    type: 'radio',
                    children: (
                      <Radio.Group onChange={changeType} disabled={id ? true : false}>
                        <Radio value={'enterprise'}>商家</Radio>
                        <Radio value={'personal'}>个人</Radio>
                      </Radio.Group>
                    ),
                    data: 'typeCode',
                  },
                  { name: 'vendorCode', label: '账号', spanCol: 8 },
                  { name: 'name', label: '承包商名称', spanCol: 8 },
                  {
                    name: 'businessLicence',
                    label: '信用代码',
                    spanCol: 8,
                    isHideItem: typeKey === 'enterprise' ? false : true,
                  },
                  { name: 'emails', label: '邮箱', spanCol: 8 },
                  { name: 'corporateName', label: '法人姓名', spanCol: 8 },
                  {
                    name: 'corporateCode',
                    label: '法人证件号',
                    spanCol: 8,
                    children: () => (
                      <div style={{ color: 'rgb(102, 102, 102)' }}>
                        <span>{info?.corporateCode}</span>
                        {authDict['lookWorkerDetail'] ? (
                          info && info?.corporateCode && info?.corporateCode.includes('*') ? (
                            <EyeInvisibleOutlined
                              onClick={() => setPhone('corporateCode', true)}
                              style={{ cursor: 'pointer' }}
                            />
                          ) : (
                            <EyeOutlined
                              onClick={() => setPhone('corporateCode', false)}
                              style={{ cursor: 'pointer' }}
                            />
                          )
                        ) : null}
                      </div>
                    ),
                  },
                  {
                    name: 'phone',
                    label: '法人电话',
                    spanCol: 8,
                    children: () => (
                      <div style={{ color: 'rgb(102, 102, 102)' }}>
                        <span>{info?.phone}</span>
                        {authDict['lookWorkerDetail'] ? (
                          info && info?.phone && info?.phone.includes('*') ? (
                            <EyeInvisibleOutlined
                              onClick={() => setPhone('phone', true)}
                              style={{ cursor: 'pointer' }}
                            />
                          ) : (
                            <EyeOutlined
                              onClick={() => setPhone('phone', false)}
                              style={{ cursor: 'pointer' }}
                            />
                          )
                        ) : null}
                      </div>
                    ),
                  },
                  { name: 'managerName', label: '负责人姓名', spanCol: 8 },
                  {
                    name: 'managerPhone',
                    label: '负责人电话',
                    spanCol: 8,
                    children: () => (
                      <div style={{ color: 'rgb(102, 102, 102)' }}>
                        <span>{info?.managerPhone}</span>
                        {authDict['lookWorkerDetail'] ? (
                          info && info?.managerPhone && info?.managerPhone.includes('*') ? (
                            <EyeInvisibleOutlined
                              onClick={() => setPhone('managerPhone', true)}
                              style={{ cursor: 'pointer' }}
                            />
                          ) : (
                            <EyeOutlined
                              onClick={() => setPhone('managerPhone', false)}
                              style={{ cursor: 'pointer' }}
                            />
                          )
                        ) : null}
                      </div>
                    ),
                  },
                  {
                    name: 'billingType',
                    label: '开票类型',
                    type: 'select',
                    data: 'billingTypeEnum',
                    comConfig: {
                      fieldNames: {
                        label: 'description',
                        value: 'key',
                      },
                    },
                    spanCol: 8,
                  },
                  {
                    name: 'taxRate',
                    label: '税率',
                    type: 'select',
                    data: 'taxRateList',
                    comConfig: {
                      fieldNames: {
                        label: 'name',
                        value: 'key',
                      },
                    },
                    spanCol: 8,
                  },
                  //
                  {
                    name: 'statusName',
                    label: '认证状态',
                    spanCol: 4,
                    seeMethodText: authDict['authentication']
                      ? info?.statusName === '已认证'
                        ? '查看认证'
                        : '去认证'
                      : ' ',
                    seeMethod: () => {
                      onAuthentication(info)
                    },
                  },
                  { name: 'address', label: '地址', spanCol: 24 },
                  { name: 'remarks', label: '备注', spanCol: 24 },
                  {
                    name: 'fileInfolist',
                    label: '附件(1-3张图)',
                    spanCol: 24,
                    htmlFor: 'fileInfolist',
                    children: <SFormImagesList />,
                  },
                ],
              },
              {
                title: '开户信息',
                titleMode: 'drawer',
                formItem: bankItem
                  ? [
                      {
                        name: 'bankName',
                        label: '银行名称',
                        type: 'select',
                        data: 'bankNameList',
                        spanCol: 8,
                      },
                      {
                        name: 'cityName',
                        label: '所在城市',
                        type: 'select',
                        data: 'banksAreasList',
                        spanCol: 8,
                      },
                      {
                        name: 'bankBranchName',
                        label: '支行名称',
                        type: 'select',
                        data: 'banksLocationsList',
                        spanCol: 8,
                      },
                      {
                        name: 'bankBranchNumber',
                        label: '银行网点联行号',
                        spanCol: 8,
                        comConfig: {
                          disabled: true,
                        },
                      },
                      { name: 'accountCode', label: '账号', spanCol: 8 },
                      { name: 'name', label: '账号名称', spanCol: 8 },
                      { name: 'bankAddress', label: '地址', spanCol: 8 },
                      {
                        name: 'accountImgFrontUrl',
                        label: '银行卡正面',
                        spanCol: 8,
                        htmlFor: 'accountImgFrontUrl',
                        required: true,
                        children: <SFormImagesList />,
                      },
                      {
                        name: 'accountImgBackUrl',
                        label: '银行卡背面',
                        spanCol: 8,
                        htmlFor: 'accountImgBackUrl',
                        required: true,
                        children: <SFormImagesList />,
                      },
                    ]
                  : [],
              },
              {
                title: '合作信息',
                titleMode: 'drawer',
                type: 'multiple',
                formName: 'vendorOrgList',
                formItem: [
                  {
                    label: '门店',
                    name: 'companyId',
                    required: true,
                    spanCol: 8,
                    children: (_formRef?: any, _formItem?: any, index?: any) => {
                      return <span>：{info?.vendorOrgList[index]?.companyName}</span>
                    },
                  },
                  {
                    label: '分配模式',
                    name: 'allocationModes',
                    type: 'select',
                    data: 'distributionTypeEnum',
                    comConfig: {
                      mode: 'multiple',
                      fieldNames: {
                        label: 'description',
                        value: 'key',
                      },
                    },
                    spanCol: 8,
                  },
                  {
                    label: '合作周期',
                    name: 'cycleTime',
                    spanCol: 8,
                    children: (_formRef?: any, _formItem?: any, index?: any) => {
                      return <RangePicker disabled />
                    },
                  },
                  {
                    label: '签章方式',
                    tooltip: '开启电子签有效',
                    name: 'signatureMode',
                    type: 'select',
                    comConfig: {
                      fieldNames: {
                        label: 'description',
                        value: 'key',
                      },
                    },
                    data: 'signatureModeEnum',
                    spanCol: 8,
                  },
                ],
              },
            ]}
          />
        </Card>
      </SBack>
    </Spin>
  )
}

export default WorkerManagementAddOrEdit
